export default __webpack_public_path__ + "static/media/mega.7db01fe6.png";